import React from 'react';
import PropTypes from 'prop-types';

export class LoadingRow extends React.Component {
  static propTypes = {
    columns: PropTypes.array
  };

  static defaultProps = {
    columns: []
  }

  displayLoadingBlank() {
    return (<p>
      <span className="loading-span" />
    </p>)
  }

  renderStandardBlanks = () => {
    let jsx = [];
    for(let i = 0; i < this.props.columns.length-1; i++) {
      jsx.push(<td key={i}>
        {this.displayLoadingBlank()}
      </td>);
    }
    return jsx;
  }

  render() {
    return (<tr className="app-loading-row">
      <th scope="row">
        <div className="app-logo" aria-hidden="aria-hidden">
          <span className="loading-img"/>
        </div>
        <div className="app-name">
          {this.displayLoadingBlank()}
          {this.displayLoadingBlank()}
        </div>
      </th>
      {this.renderStandardBlanks()}
    </tr>);
  }
}
